import React from 'react';
import Icon from 'components/icons';
import cx from 'classix';
import * as styles from './styled/styles.module.css';

export interface PromoCodeBadgeProps {
  label?: string;
  code: string;
  onPromoCodeClick?: () => void;
  onRemoveClick?: () => void;
}

export const PromoCodeBadge: React.FC<PromoCodeBadgeProps> = ({ label, code, onPromoCodeClick, onRemoveClick }) => {
  return (
    <div className={cx(styles.badgeContainer, onPromoCodeClick && styles.clickable)} onClick={onPromoCodeClick}>
      {label}
      <span className={styles.code} id="promoCodeSpan">
        {code}
      </span>
      {onRemoveClick &&
        <Icon icon="boldClose" viewBox="0 0 16 16" color="#ffffff" onClick={onRemoveClick}/>
      }
    </div>
  );
};

export default PromoCodeBadge;
